document.addEventListener("DOMContentLoaded", function () {
  const tabTitles = document.querySelectorAll(".tab-title");
  const tabPanels = document.querySelectorAll(".tab-panel");
  const productGridCollection = document.querySelector(
    ".product-grid-collection"
  );

  function showAllContent() {
    tabPanels.forEach((panel) => {
      panel.style.display = "block";
    });
  }

  tabTitles.forEach((title, index) => {
    title.addEventListener("click", () => {
      const tabIndex = title.getAttribute("data-tab-index");

      tabTitles.forEach((t) => {
        t.classList.remove("active");
      });

      title.classList.add("active");

      tabPanels.forEach((panel) => {
        panel.style.display = "none";
      });

      if (tabIndex === "0") {
        showAllContent();
      } else {
        tabPanels[tabIndex - 1].style.display = "block";
      }
    });
  });

  showAllContent();

  const filterCheckboxes = document.querySelectorAll(
    ".product-grid-filter .filter-option input"
  );
  const selectedSizes = document.querySelectorAll(
    ".product-grid-filter .filter-option input:checked"
  );

  filterCheckboxes.forEach((filterCheckbox) => {
    filterCheckbox.addEventListener("change", function () {
      let filterBox = filterCheckbox.closest(".product-grid-filter-wrapper");
      let productGrid = filterBox.nextElementSibling;
      findMatchingVariant(productGrid, this.value);
    });
  });

  // Function to find matching variant
  function findMatchingVariant(productGrid, selectedSizeFilter) {
    let productCards = productGrid.querySelectorAll(".variant-card");
    productCards.forEach((card) => {
      const option1 = card.getAttribute("data-option-1");
      const option2 = card.getAttribute("data-option-2");
      const option3 = card.getAttribute("data-option-3");
      const sizeVariant = selectedSizeFilter;

      // Store the options in an array
      const cardVariantOptions = [option1, option2, option3];
      // Filter options to exclude any that contain the value "S"
      const filteredOptions = cardVariantOptions.filter(option => option !== "L");
      const cardPorductId = card.getAttribute("data-product-id");
      // Iterate over each product's variants to find matches
      Object.keys(productsVariants).forEach((productId) => {
        const product = productsVariants[productId];
        product.forEach((variant) => {
          // Check if the variant options match the data attributes and selected size
          const matchesOption1 = filteredOptions[0] != null && variant.options.some((opt) => opt === filteredOptions[0]);
          const matchesOption2 = sizeVariant != null && variant.options.some((opt) => opt === sizeVariant);
          const matchesOption3 = filteredOptions[1] != null && variant.options.some((opt) => opt === filteredOptions[1]);
          if (
            (filteredOptions[0] == null || matchesOption1) &&
            (sizeVariant == null || matchesOption2) &&
            (filteredOptions[1] == null || matchesOption3) &&
            cardPorductId == productId
          ) {
            // Output or use variant ID and URL as needed
            const formWrapper = card.querySelector(".variant-form-wrapper");

            formWrapper.style.display = "block";
            if (variant.available) {
              card
                .querySelector(".variant_card__media")
                ?.setAttribute(
                  "data-href", variant.url
                );
              card?.setAttribute(
                "data-href",
                variant.url
              );
              card?.setAttribute(
                "data-variant-id",
                variant.id
              );
              card?.setAttribute(
                "data-variant-title",
                variant.title
              );
              card.querySelector(
                '.variant-form-wrapper input[name="id"]'
              ).value = variant.id;
              formWrapper
                .querySelector("form .submit-button  .addto-cart")
                ?.classList.remove("hidden");
              formWrapper
                .querySelector("form .submit-button  .sold-out-message")
                ?.classList.add("hidden");
              formWrapper
                .querySelector("form .submit-button ")
                ?.removeAttribute("disabled");
            } else {
              formWrapper
                .querySelector("form .submit-button ")
                ?.setAttribute("disabled", "true");
              formWrapper
                .querySelector("form .submit-button  .addto-cart")
                ?.classList.add("hidden");
              formWrapper
                .querySelector("form .submit-button  .sold-out-message")
                ?.classList.remove("hidden");
            }
          }
        });
      });
    });
  }
  const sizeChart = document.querySelector('.bundle-size-guide-pop-up');

  /*   document.querySelectorAll('.product-bundle-size-guide-title').addEventListener('click', function(){
      sizeChart.style.display = "block";
    });
    
    document.querySelector('.bundle-size-guide-pop-up-close').addEventListener('click', function(){
      sizeChart.style.display = "none";
    }); */

  // size guide trigger
  $(document).on("click", ".bundle-size-guide-trigger", function (e) {
    $(this)
      .parents(".product-bundle-size-guide-title")
      .siblings(".bundle-size-guide-pop-up")
      .show()
    $('body').addClass('overflow-hidden');
  });

  // size guide trigger close
  $(document).on("click", ".bundle-size-guide-pop-up-close", function (e) {
    $(this).parents(".bundle-size-guide-pop-up").hide();
    $('body').removeClass('overflow-hidden');
  });

  selectedSizes.forEach((size) => {
    let productGrid = size.closest(
      ".product-grid-filter-wrapper"
    ).nextElementSibling;
    findMatchingVariant(productGrid, size.value);
  });

});


document.addEventListener('DOMContentLoaded', function () {
  // Select all collection grids using the 'collection--grid' class
  console.log(collectionGridImages);
  Object.keys(collectionGridImages).forEach((collectionId) => {
    var collectionGrid = collectionGridImages[collectionId];
    if (collectionGrid.length > 0) {
      const collectionGridContainer = document.querySelector(`div[data-featured-id="${collectionId}"]`);
      console.log(collectionGridContainer)

      const productGrid = collectionGridContainer.querySelector('#product-grid');

      // Get all product cards in this collection
      const productCards = productGrid.querySelectorAll('.grid__item');

      collectionGrid.forEach((gridImage) => {
      
        // Get the next product card
        const fourthProductCard = productCards[(gridImage.position - 1)];

        // Create a new list item for the featured image
        const featuredImageItem = document.createElement('li');
        featuredImageItem.classList.add('grid__item', 'featured-image-card');

        // Create the featured image element
        const featuredImage = document.createElement('img');
        featuredImage.src = gridImage.image; // Use the collection image URL
        featuredImage.classList.add('featured-image');

        // Append the image to the new list item
        featuredImageItem.appendChild(featuredImage);
        // Insert the featured image before product card
        fourthProductCard.before(featuredImageItem);
        featuredImageItem.style.maxHeight = fourthProductCard.clientHeight + 'px';
      });

    }
  });
});